export const ETemplateText: any = {

  /**
   * MEDELLÍN
   */
  SIMULADOR_CCMA: {
    NombreCamara: 'Cámara de Comercio de Medellín',
    UrlCamara: 'https://www.camaramedellin.com.co/',
    UrlCamaraShort: 'www.camaramedellin.com.co',
    UrlMatApp: 'https://virtuales.camaramedellin.com.co/MatriculaInscripcionVirtual/!/home/inicio',
    UrlDispatch: 'https://www.camaramedellin.com.co/servicios-registrales/acerca-de-los-servicios-registrales/taquilla-virtual',
    UrlCiiuConsult: 'http://virtuales.camaramedellin.com.co/consultas/ciiu.html',
    UrlWebServices: 'https://camaracomerciomedellin-f2723.web.app/services/',
    UrlRenovation: 'http://renovacionmatricula.camaramedellin.com.co/',
    UrlLogo: 'assets/images/logo-brand.png',
    Location: 'Medellín',
    privacyTerms: `
    “Los datos personales que se solicitan a través de esta página serán tratados por
    LA CAMARA DE COMERCIO DE MEDELLÍN PARA ANTIOQUIA, en adelante, LA CAMARA, de manera
    confiable y segura con la finalidad de entregar la simulación de costos de formalización
    solicitada por el USUARIO y cumplir con la prestación del servicio de manera idónea.
    Así mismo LA CAMARA podrá usar sus datos para informarle sobre nuestros productos,
    servicios y eventos; realizar gestión comercial para la promoción de tales servicios; realizar análisis
    prospectivo sobre tendencias y gustos de los consumidores que nos permitan otorgarles beneficios alrededor
    de la organización y análisis de la información que administra o gestiona LA CAMARA, bien en sus propios
    registros públicos o los de terceros. Consulte la Política de Protección de Datos Personales de la CAMARA
    en el link: <a href="http://www.camaramedellin.com.co/site/Terminos-y-Condiciones.aspx" target="_blank">
    http://www.camaramedellin.com.co/site/Terminos-y-Condiciones.aspx
    </a>.
    Cualquier consulta, reclamación, petición de modificación, rectificación o cancelación de sus datos
    personales podrá efectuarla a través del correo electrónico:
    <a href="mailto:habeasdata@camaramedellin.com.co"><span>habeasdata@camaramedellin.com.co</span></a>
    <br>
    <br>
    Manifiesto conocer la política de protección de datos de LA CAMARA y acepto el tratamiento de los datos
    entregados para los fines antes comunicados. Así mismo expreso que tengo facultad para llevar a cabo las
    operaciones requeridas para acceder al simulador de costos de Formalización.”
  `,
    userTerms: `
    <b> TÉRMINOS Y CONDICIONES DE USO PARA EL  SIMULADOR DE FORMALIZACIÓN.</b>
    <br>
    <p class="text-justify">
      En su propósito de contribuir al desarrollo empresarial, la Cámara de Comercio de Medellín para Antioquia
      (en adelante también se identificará como La CCMA) pone a disposición del público el siguiente simulador
      que permite determinar los costos aproximados en los trámites más comunes en el proceso de formalización
      empresarial, en aras de proyectar los pagos aproximados necesarios para la adquisición de competencias
      fundamentales que le permiten al comerciante hacer parte del mercado competitivo.
      <br>
      El uso del simulador, la responsabilidad de la Cámara de Comercio de Medellín para Antioquia y los deberes
      de los usuarios estarán regidos por las presentes condiciones de uso. Para tal propósito, el simulador
      dispondrá de las ayudas identificadas por un signo de interrogación ubicado en la parte derecha después
      del espacio destinado para la respuesta a cada pregunta. El cuestionario inicial permite determinar los
      costos vinculados a las entidades que intervienen en el ejercicio de actividades industriales, económicas
      y comerciales, donde el usuario es quien determina si desea conocer el costo de los trámites con todas las
      entidades vinculadas al simulador o solo algunos costos, bien sea porque la actividad que realiza no
      requiere todas las diligencias contempladas en la herramienta, o porque así lo decide el usuario del servicio.
      <br>
      La aceptación de las presentes condiciones de uso se hará, por parte del usuario al momento de hacer clic
      en la opción “he leído y acepto las condiciones del servicio y el aviso de privacidad”. La aceptación de las
      presentes condiciones de uso crea entre La CCMA y el usuario una relación de tipo contractual. Cualquier
      persona que desee acceder y/o utilizar el simulador podrá hacerlo sujetándose a estos términos y condiciones
      de uso, pero además se compromete a acatar todas las instrucciones e información incluida en el simulador, las
      cuales también se entienden incorporadas al presente acuerdo.
      <br>
      La CCMA se reserva el derecho a modificar en cualquier momento el contenido del simulador o las condiciones
      de uso, por lo tanto, se sugiere consultar periódicamente el contenido del mismo.
      <br>
      La simulación de costos aproximados en el proceso de desarrollo empresarial, referida en el presente documento
      de términos de uso, se adelantará únicamente a través de la herramienta dispuesta por la Cámara de Comercio
      de Medellín para Antioquia y bajo las condiciones de uso que a continuación se describen.
    </p>
    <br>
    <b>CONDICIONES DE ACCESO:</b>
    <br>
    <p class="text-justify">
      El acceso al simulador de costos se realiza seleccionando la forma cómo se va a ejercer la actividad
      comercial, digitando número de identificación y correo electrónico, previa lectura y aceptación de
      las condiciones del servicio y el aviso de privacidad por parte del usuario.
      <br>
      El simulador solo aplica para los 69 municipios comprendidos dentro de la jurisdicción de la Cámara de
      Comercio de Medellín para Antioquia: Medellín, Cáceres, Caucasia Tarazá, Angostura, Belmira, Briceño, Carolina,
      Campamento, Don Matías, Entrerríos, Gómez Plata, Guadalupe, Ituango, San Andrés de Cuerquia,
      San Jose de la Montaña, San Pedro de los Milagros, Santa Rosa de Osos, Toledo, Valdivia, Yarumal, Bello,
      Barbosa Copacabana, Girardota, Santo Domingo, Angelópolis, Amagá Titiribí, Fredonia, Venecia, Montebello,
      Santa Bárbara, La Pintada, Valparaíso, Caramanta, Támesis, Jericó, Pueblorrico, Tarso, Jardín, Andes, Betania,
      Hispania, Ciudad Bolívar, Salgar, Concordia, Betulia, Urrao, Caicedo, Anzá, Abriaquí, Armenia, Buriticá,
      Cañasgordas, Ebéjico, Frontino, Giraldo, Heliconia, Liborina, Murindó, Olaya, Peque, Sabanalarga,
      San Jerónimo, Santa Fe de Antioquia, Sopetrán, Vigía del Fuerte, Uramita.
      <br>
      El procedimiento para calcular los costos aproximados que arroja el simulador, se adelanta ingresando las
      respuestas de forma acertada a las preguntas relacionadas con la información que determina las tarifas a
      pagar en las entidades vinculadas al servicio, para tal fin, es necesario tener a la mano datos relacionados
      con los activos del comerciante, activos del negocio, número de empleados, edad de los comerciantes o socios
      de la persona jurídica que se pretende constituir, si usa obras que no son de su autoría, verificar si
      contamina los recursos naturales, entre otra información relevante para los datos del simulador.
      <br>
      Las personas que usen el simulador deben ser jurídicamente capaces en los términos previstos en la
      legislación colombiana vigente y es responsable de los datos ingresados en el simulador, incluidos
      los campos obligatorios y no obligatorios, deberán ser veraces y fidedignos. La CCMA no será responsable
      por las inexactitudes, omisiones o falsedades en que pueda incurrir el usuario al revelar la información requerida.
      <br>
      En suma, para ingresar al simulador se requiere el cumplimiento de las siguientes condiciones:
      <br>
      * Leer las condiciones de uso y el aviso de privacidad
      <br>
      * Seleccionar la forma cómo va a ejercer la actividad comercial (persona natural o persona jurídica)
      <br>
      * Digitar el número de identificación del usuario.
      <br>
      * Digitar un correo electrónico.
      <br>
      * Revelar información fidedigna y veraz.
      <br>
      * No incurrir en malas prácticas comerciales.
      <br>
      * Hacer buen uso del servicio en general.
    </p>
    <br>
    <b>ALCANCE DEL SERVICIO:</b>
    <br>
    <p class="text-justify">
      El simulador ha sido diseñado para permitir al usuario realizar un estimativo de los costos que debe tener en
      cuenta en el proceso de desarrollo empresarial, la CCMA no garantiza la vigencia de las tarifas ni la exactitud
      de las mismas en los trámites que abarca, por lo anterior es responsabilidad del usuario ratificar los valores
      que proyecta el simulador con cada una de las entidades vinculadas a la herramienta.
      <br>
      Para calcular los costos asociados a los trámites que se adelantan ante OSA, Sayco, Acinpro e INVIMA, cuando
      sea necesario por las características del negocio o de los productos o servicios que se prestan, es
      responsabilidad del usuario acceder a los links incluidos en las preguntas que lo llevan directamente al
      sitio web de estas entidades, quienes cuentan con un simulador de costos para los trámites que se realizan
      ante estas instituciones. Una vez el usuario ingresa al simulador incluido en el sitio web diferente al de
      la CCMA, es responsable de ingresar el valor a pagar arrojado, en el simulador de costos de la CCMA para
      que sea incluido en el resultado final.
      <br>
      La CCMA no es responsable de la funcionalidad de los sitios web, su disponibilidad permanente o veracidad
      en el resultado que arrojen. Así mismo, es responsabilidad del usuario utilizar los links incluidos en
      algunas ayudas en caso de tener dudas con la respuesta que va a incluir en el simulador, ya que este enlace
      le permite el usuario conocer de forma amplia los diferentes trámites que se llevan cabo en cada entidad y
      las diferencias entre ellos. La inclusión de cualquiera de estos enlaces no implica aprobación por parte de
      la Cámara de Comercio de Medellín para Antioquia a ninguno de estos sitios ni ninguna asociación con sus operadores.
      <br>
      Para los efectos del simulador se entenderá por Pequeña Empresa Joven aquella que cumpla las siguientes condiciones:
      <br>
      La empresa conformada por personas naturales que tengan entre 18 y hasta 35 años. Tratándose de las personas
      jurídicas, la empresa que tenga participación de uno o varios jóvenes como socios o accionistas y que
      tengan entre 18 y hasta 35 años, que representen como mínimo la mitad más uno de las cuotas, acciones o
      participaciones en que se divide su capital.
      <br>
      La empresa cuyo personal no sea superior a 50 trabajadores y cuyos activos totales no superen los 5.000 salarios
      mínimos mensuales legales vigentes.
      <br>
      *Estos requisitos deben ser concurrentes.
      <br>
      <b>Beneficiarias de la Ley de emprendimiento juvenil</b>: Las personas naturales y jurídicas que conformen pequeñas
      empresas jóvenes, que inicien su actividad económica a partir de la promulgación de la Ley y que no estén dentro
      del régimen de exclusiones. Se entenderá por inicio de la actividad económica principal la fecha de inscripción
      en el registro mercantil de la correspondiente Cámara de Comercio.
      <br>
      <b>Beneficios</b>: De conformidad con lo previsto en el artículo 3° de la ley 1780 de 2016, el beneficio
      consiste en la exención del pago de la matrícula mercantil y de la renovación del primer año siguiente al
      inicio de la actividad económica principal.
      <br>
      <b>Perdida de los beneficios</b>: Los beneficios de que trata el artículo 3° de la Ley, se perderán en los
      siguientes eventos:
      <br>
      <b>a)</b>&nbsp;Incumplimiento de la renovación de la matrícula mercantil dentro de los tres (3) primeros
      meses del año.
      <br>
      <b>b)</b>&nbsp;Impago de los aportes al Sistema de Seguridad Social Integral y demás contribuciones de nómina
      de la empresa.
      <br>
      <b>c)</b>&nbsp;Incumplimiento de las obligaciones en materia tributaria.
      <br>
      <br>
      <br>
      * Para efectos del no cobro de la primera renovación la persona natural o jurídica, deberá declarar que mantiene
      el cumplimiento de los requisitos estipulados.
      <br>
      Las condiciones que debe cumplir La pequeña empresa joven determinadas en este documento podrán variar de
      acuerdo a la reglamentación que se expida en la materia. El simulador podrá variar las preguntas o la información
      en cualquier momento para cumplir con las modificaciones o actualizaciones normativas en el tema.
      <br>
      La información determinante para liquidar los pagos en la CCMA será la contenida en los documentos que se
      presentan en las taquillas de la Cámara y no la información incluida en el simulador, en este sentido, si el
      simulador arroja un valor de cero pesos por concepto de matrícula persona natural o jurídica, el usuario acepta
      que esta tarifa podrá variar según la información presentada al momento de radicar el trámite, relacionada con
      el cumplimiento de las condiciones que se requieren para ser catalogada como pequeña empresa joven.
      <br>
      Lo mismo sucede con el concepto identificado como “Pago renovación anual de la matrícula mercantil del
      comerciante” en el cuadro correspondiente a los costos del año dos, si el valor arrojado por el simulador
      es cero, el usuario acepta que esta tarifa podrá variar si no mantiene el cumplimiento de los requisitos
      estipulados para ser pequeña empresa joven, o en el caso de pérdida de beneficios o en el evento de cambios
      normativos que impida la aplicación de los beneficios.
      <br>
      El costo aproximado del impuesto de Industria y Comercio debe ser ratificado con la alcaldía municipal encargada
      de su recaudo, las tarifas incluidas en el simulador pueden ser modificadas por cada alcaldía municipal de
      los 69 municipios sin previo aviso a la CCMA, por lo anterior el usuario es responsable de verificar la
      vigencia de los costos vinculados a este tributo de carácter municipal.
    </p>
    <br>
    <b>RESTRICCIONES.</b>
    <br>
    <p class="text-justify">
      <b>-</b>&nbsp;Los costos que arroja el simulador o la impresión de los mismos no reemplazan las liquidaciones que
      realizan las entidades vinculadas el simulador, no constituye una pre liquidación, ni puede presentarse para
      realizar reclamos por las diferencias entre los pagos que arroja el simulador y las liquidaciones que realiza
      cada entidad al momento de recibir la solicitud de radicación de cada trámite.
      <br>
      <b>-</b>&nbsp;No será posible realizar reclamos frente a la CCMA o frente a cualquiera de las entidades vinculadas
      al simulador, por las diferencias que se tengan entre los pagos que arroja el servicio y las tarifas que liquida
      cada entidad con la presentación efectiva de la solicitud correspondiente.
      <br>
      <b>-</b>&nbsp;No será posible arrojar costos aproximados de usuarios cuyo domicilio corresponda a un municipio
      diferente a los indicados en las condiciones de acceso, lo mismo sucede cuando la ubicación del establecimiento de
      comercio corresponde a un municipio por fuera de la jurisdicción de la CCMA.
      <br>
      <b>-</b>&nbsp;El simulador no es un medio para radicar los trámites que liquida, para ello consulte el sitio web
      de cada entidad y siga las instrucciones que contenga para el efecto.
      <br>
      Teniendo en cuenta lo anterior, si el usuario advierte que las limitaciones y parámetros del simulador no se
      adecuan a sus necesidades o a las circunstancias especiales del trámite que pretende realizar, conoce que debe
      abstenerse de utilizarlo, pues esta herramienta no incluye la totalidad de trámites vinculados al proceso de
      desarrollo empresarial.
      <br>
      El uso del simulador no convierte a la Cámara de Comercio de Medellín para Antioquia en un asesor jurídico o
      contable del usuario. De modo que la CCMA no asume ningún tipo de obligación con respecto a la pertinencia y
      procedencia de los trámites sujetos a costos aproximados. La pertinencia, legalidad y conveniencia de realizar
      cada uno de los trámites o de acogerse o no a los beneficios de la Ley de emprendimiento juvenil serán
      responsabilidad exclusiva del usuario, lo que implica que en ningún caso la Cámara de Comercio de Medellín para
      Antioquia indemnizará los perjuicios que pudiera sufrir si lleva a cabo los trámites que no se adecuen a las
      condiciones de su negocio por la interpretación que el usuario le haya dado a la información publicada en el
      simulador o en los sitios web de las entidades vinculadas al mismo. Tampoco será sujeta a revisión de la CCMA la
      documentación que el usuario del servicio deba presentar frente a cada trámite que pretenda llevar a cabo,
      ni dará el visto bueno sobre la procedencia de los trámites seleccionados en el servicio.
      <br>
      En caso de considerarlo conveniente, la CCMA le recomienda buscar asesoría jurídica y contable profesional.En todo
      caso, puede solicitar información adicional en cada una de las entidades que hacen parte de los trámites incluidos
      en el simulador.
    </p>
    <br>
    <b>OTRAS CONSIDERACIONES DEL SERVICIO:</b>
    <br>
    <p class="text-justify">
      Tenga en cuenta que la información que ingrese al simulador se cargará durante y podrá recuperarla cada vez que
      ingrese con su número de identificación y correo electrónico al servicio. Al finalizar este tiempo los datos
      ingresados serán eliminados y el usuario deberá responder nuevamente las preguntas necesarias para arrojar los
      pagos aproximados en Cámara y los pagos aproximados con otras entidades.
    </p>
    <br>
    <b>CONDICIONES O RESTRICCIONES DE USO DEL CONTENIDO:</b>
    <br>
    <p class="text-justify">
      Usted se compromete a hacer un uso adecuado del simulador. De manera enunciativa, pero no limitativa, usted
      se compromete a NO:
      <br>
      <b>1.</b>&nbsp;Utilizar el contenido para incurrir y/o incitar a terceros a incurrir en actividades ilícitas,
      ilegales o contrarias a la buena fe y al orden público, o para difundir contenidos o propaganda de carácter
      racista, xenófobo, pornográfico, de apología del terrorismo o atentatorio contra los derechos humanos.
      <br>
      <b>2.</b>&nbsp;Usar secuencias de comandos automatizados para recopilar información publicada en el portal o a
      través del portal o para interactuar de cualquier otro modo con los mismos.
      <br>
      <b>3.</b>&nbsp;Provocar daños en los sistemas físicos y lógicos de la Cámara de Comercio de Medellín para
      Antioquia, de sus proveedores o de terceras personas, introducir o difundir en la red virus informáticos,
      troyanos, código malicioso o cualesquiera otros sistemas físicos o lógicos que sean susceptibles de provocar
      daños en y/o estén diseñados para interrumpir, destruir o limitar la funcionalidad de cualquier software,
      hardware o equipo de telecomunicaciones o para dañar, deshabilitar, sobrecargar o perjudicar el portal de
      cualquier modo.
      <br>
      <b>4.</b>&nbsp;Intentar acceder, recolectar o almacenar los datos personales de otros visitantes y/o usuarios
      del simulador y, en su caso, utilizar las cuentas de correo electrónico de otros visitantes y/o usuarios y
      modificar o manipular sus mensajes.
      <br>
      <b>5.</b>&nbsp;No descargar, reproducir, copiar, enmarcar, compilar, cargar o republicar en ningún sitio de
      Internet, Intranet o Extranet, ni adaptar, modificar, transmitir, vender, comunicar al público, total o
      parcialmente, el contenido de la información que encontrará en el simulador. Cualquiera de estas actividades
      requiere de la autorización previa, expresa y por escrito de la Cámara de Comercio de Medellín para Antioquia, so
      pena de incurrir en violación a los derechos de propiedad intelectual, y someterse a las consecuencias civiles
      y penales de tal hecho, así como al derecho de la Cámara de Comercio de Medellín para Antioquia de revocar
      la autorización, aquí conferida.
      <br>
      <b>6.</b>&nbsp;No hacer uso del simulador para fines distintos a obtener un valor aproximado de algunos de los
      trámites necesarios para el proceso de desarrollo empresarial.
    </p>
    <br>
    <b>LIMITACIÓN DE RESPONSABILIDAD:</b>
    <br>
    <p class="text-justify">
      La Cámara de Comercio de Medellín para Antioquia no es responsable por:
      <br>
      <b>1.</b>&nbsp;Las caídas del servicio virtual y la falla en el suministro del servicio, quedando exonerada por
      cualquier tipo de daños y perjuicios causados debido a la no disponibilidad y/o interrupción del servicio
      ocasionados por fallas o no disponibilidad de las redes y servicios de telecomunicaciones utilizados para
      soportar el portal, y que sean ajenos a su voluntad.
       <br>
      <b>2.</b>&nbsp;Los daños y perjuicios causados por virus informáticos, troyanos, código malicioso o cualesquiera
      otros sistemas físicos o lógicos a los sistemas de los usuarios.
       <br>
      <b>3.</b>&nbsp;Errores mecanográficos y/o tipográficos que aparezcan en el contenido.
       <br>
      <b>4.</b>&nbsp;El contenido o disponibilidad de los sitios vinculados mediante hipervínculos que aparezcan en el
      simulador (los "Sitios Vinculados"), incluyendo sin limitación, cualquier vínculo contenido en los Sitios
      Vinculados, cualquier cambio o actualización a los Sitios Vinculados, cualquier tipo de transmisión recibida o
      enviada desde o hacia Sitios Vinculados, o el funcionamiento incorrecto de los Sitios Vinculados.
       <br>
      <b>5.</b>&nbsp;La inactivación de los usuarios del sistema por realización de prácticas indebidas o restrictivas.
       <br>
      <b>6.</b>&nbsp;Por la información suministrada en el simulador que ocasione daños o perjuicios a terceros o
      se suplante la identidad de un tercero.
    </p>
    <br>
    <b>DERECHOS DE PROPIEDAD INTELECTUAL:</b>
    <br>
    <p class="text-justify">
      El contenido del simulador, incluyendo dentro de tal concepto los textos, la información, las imágenes, el diseño
      gráfico, las fotografías, los logos y el contenido multimedia; así como el software que soporta el simulador y sus
      licencias son de propiedad exclusiva de la Cámara de Comercio de Medellín para Antioquia o de terceros que han
      otorgado licencia de uso a la misma lo que implica que todo el contenido del simulador está protegido por la
      Ley y no le confiere al usuario ningún derecho para su uso, almacenamiento, conservación, divulgación o
      explotación distinto al de la simple visualización y utilización para los efectos propios de la simulación
      de costos en el proceso de desarrollo empresarial.
    </p>
    <br>
    <b>CLÁUSULA COMPROMISORIA:</b>
    <br>
    <p class="text-justify">
      Las controversias surgidas entre la Cámara de Comercio de Medellín para Antioquia y el(los) usuario(s) en
      razón de la existencia del contrato que por medio de estos términos de uso los vincula, o en razón de su
      interpretación, desarrollo o terminación, así como los derivados del incumplimiento contractual o la acción
      contractual o extracontractual de indemnización de perjuicios derivados del simulador, se someterán a la
      decisión de un (1) árbitro designado por sorteo entre la lista de sus árbitros por el Centro de Conciliación
      y Arbitraje del Colegio de Abogados de Medellín. El arbitraje será en derecho, tendrá como sede la ciudad de
      Medellín y se someterá a las normas que rigen el arbitraje legal.
    </p>
    <br>
    <b>LEGISLACIÓN APLICABLE:</b>
    <br>
    <p class="text-justify">
      Los presentes términos de uso se regirán e interpretarán de acuerdo con las normas vigentes en la República
      de Colombia, especialmente en las contenidas en el Código de Comercio; Ley 1780 de 2016, Estatutos tributarios
      de los municipios abordados para el simulador, Decisión 486 de 2000 y normas concordantes sobre propiedad
      intelectual, Ley 23 de 1982 y normas concordantes o complementarias sobre derechos de autor,
      Decreto 2200 de 2005, Decreto 4725 de 2005, Resolución 1403 de 2007, Resolución 2003 de 2004,
      Resolución 4002 de 2007, Resolución 4816 de 2008 y normas concordantes o complementarias sobre trámites
      ante el INVIMA, artículo 79 de la Constitución Nacional, Decreto ley 2811 de 1.974, Ley 23 de 1973,
      Ley 99 de 1993, Decreto 1753 de 1994, Decreto 2150 de 1995 y sus normas reglamentarias, complementarias o
      modificatorias sobre permisos ambientales.
    </p>
    `
  },

  /**
   * CARTAGENA
   */
  SIMULADOR_CCCAR: {
    NombreCamara: 'Cámara de Comercio de Cartagena',
    UrlCamara: 'https://www.cccartagena.org.co/',
    UrlCamaraShort: 'www.cccartagena.org.co',
    UrlMatApp: 'http://serviciosvirtuales.cccartagena.org.co/MatriculaInscripcionVirtual/!/home/inicio',
    UrlDispatch: 'https://www.camaramedellin.com.co/servicios-registrales/acerca-de-los-servicios-registrales/taquilla-virtual',
    UrlCiiuConsult: 'http://virtuales.camaramedellin.com.co/consultas/ciiu.html',
    UrlWebServices: 'https://camaracomerciomedellin-f2723.web.app/services/',
    UrlRenovation: 'http://renovacionmatricula.camaramedellin.com.co/',
    UrlLogo: 'assets/images/logo-brand-CCCAR.png',
    Location: 'Cartagena',
    privacyTerms: `
    “Los datos personales que se solicitan a través de esta página serán tratados por
    LA CAMARA DE COMERCIO DE CARTAGENA, en adelante, LA CAMARA, de manera
    confiable y segura con la finalidad de entregar la simulación de costos de formalización
    solicitada por el USUARIO y cumplir con la prestación del servicio de manera idónea.
    Así mismo LA CAMARA podrá usar sus datos para informarle sobre nuestros productos,
    servicios y eventos; realizar gestión comercial para la promoción de tales servicios; realizar análisis
    prospectivo sobre tendencias y gustos de los consumidores que nos permitan otorgarles beneficios alrededor
    de la organización y análisis de la información que administra o gestiona LA CAMARA, bien en sus propios
    registros públicos o los de terceros. Consulte la Política de Protección de Datos Personales de la CAMARA
    en el link: <a href="http://www.camaramedellin.com.co/site/Terminos-y-Condiciones.aspx" target="_blank">
    http://www.camaramedellin.com.co/site/Terminos-y-Condiciones.aspx
    </a>.
    Cualquier consulta, reclamación, petición de modificación, rectificación o cancelación de sus datos
    personales podrá efectuarla a través del correo electrónico:
    <a href="mailto:habeasdata@camaramedellin.com.co"><span>habeasdata@camaramedellin.com.co</span></a>
    <br>
    <br>
    Manifiesto conocer la política de protección de datos de LA CAMARA y acepto el tratamiento de los datos
    entregados para los fines antes comunicados. Así mismo expreso que tengo facultad para llevar a cabo las
    operaciones requeridas para acceder al simulador de costos de Formalización.”
  `,
    userTerms: `
    <b> TÉRMINOS Y CONDICIONES DE USO PARA EL  SIMULADOR DE FORMALIZACIÓN.</b>
    <br>
    <p class="text-justify">
      En su propósito de contribuir al desarrollo empresarial, la Cámara de Comercio de Cartagena
      (en adelante también se identificará como La CCMA) pone a disposición del público el siguiente simulador
      que permite determinar los costos aproximados en los trámites más comunes en el proceso de formalización
      empresarial, en aras de proyectar los pagos aproximados necesarios para la adquisición de competencias
      fundamentales que le permiten al comerciante hacer parte del mercado competitivo.
      <br>
      El uso del simulador, la responsabilidad de la Cámara de Comercio de Cartagena y los deberes
      de los usuarios estarán regidos por las presentes condiciones de uso. Para tal propósito, el simulador
      dispondrá de las ayudas identificadas por un signo de interrogación ubicado en la parte derecha después
      del espacio destinado para la respuesta a cada pregunta. El cuestionario inicial permite determinar los
      costos vinculados a las entidades que intervienen en el ejercicio de actividades industriales, económicas
      y comerciales, donde el usuario es quien determina si desea conocer el costo de los trámites con todas las
      entidades vinculadas al simulador o solo algunos costos, bien sea porque la actividad que realiza no
      requiere todas las diligencias contempladas en la herramienta, o porque así lo decide el usuario del servicio.
      <br>
      La aceptación de las presentes condiciones de uso se hará, por parte del usuario al momento de hacer clic
      en la opción “he leído y acepto las condiciones del servicio y el aviso de privacidad”. La aceptación de las
      presentes condiciones de uso crea entre La CCMA y el usuario una relación de tipo contractual. Cualquier
      persona que desee acceder y/o utilizar el simulador podrá hacerlo sujetándose a estos términos y condiciones
      de uso, pero además se compromete a acatar todas las instrucciones e información incluida en el simulador, las
      cuales también se entienden incorporadas al presente acuerdo.
      <br>
      La CCMA se reserva el derecho a modificar en cualquier momento el contenido del simulador o las condiciones
      de uso, por lo tanto, se sugiere consultar periódicamente el contenido del mismo.
      <br>
      La simulación de costos aproximados en el proceso de desarrollo empresarial, referida en el presente documento
      de términos de uso, se adelantará únicamente a través de la herramienta dispuesta por la Cámara de Comercio
      de Cartagena y bajo las condiciones de uso que a continuación se describen.
    </p>
    <br>
    <b>CONDICIONES DE ACCESO:</b>
    <br>
    <p class="text-justify">
      El acceso al simulador de costos se realiza seleccionando la forma cómo se va a ejercer la actividad
      comercial, digitando número de identificación y correo electrónico, previa lectura y aceptación de
      las condiciones del servicio y el aviso de privacidad por parte del usuario.
      <br>
      El simulador solo aplica para los 18 municipios comprendidos dentro de la jurisdicción de la Cámara de
      Comercio de Cartagena: Cartagena de Indias, Arjona, Arroyohondo, Calamar, El Carmen de Bolívar, Clemencia,
      El Guamo, Mahates, María La Baja, San Cristóbal, San Estanislao de Kostka (Arenal), San Jacinto,
      San Juan Nepomuceno, Santa Catalina, Santa Rosa, Soplaviento, Turbaco, Turbana y Villanueva.
      <br>
      El procedimiento para calcular los costos aproximados que arroja el simulador, se adelanta ingresando las
      respuestas de forma acertada a las preguntas relacionadas con la información que determina las tarifas a
      pagar en las entidades vinculadas al servicio, para tal fin, es necesario tener a la mano datos relacionados
      con los activos del comerciante, activos del negocio, número de empleados, edad de los comerciantes o socios
      de la persona jurídica que se pretende constituir, si usa obras que no son de su autoría, verificar si
      contamina los recursos naturales, entre otra información relevante para los datos del simulador.
      <br>
      Las personas que usen el simulador deben ser jurídicamente capaces en los términos previstos en la
      legislación colombiana vigente y es responsable de los datos ingresados en el simulador, incluidos
      los campos obligatorios y no obligatorios, deberán ser veraces y fidedignos. La CCMA no será responsable
      por las inexactitudes, omisiones o falsedades en que pueda incurrir el usuario al revelar la información requerida.
      <br>
      En suma, para ingresar al simulador se requiere el cumplimiento de las siguientes condiciones:
      <br>
      * Leer las condiciones de uso y el aviso de privacidad
      <br>
      * Seleccionar la forma cómo va a ejercer la actividad comercial (persona natural o persona jurídica)
      <br>
      * Digitar el número de identificación del usuario.
      <br>
      * Digitar un correo electrónico.
      <br>
      * Revelar información fidedigna y veraz.
      <br>
      * No incurrir en malas prácticas comerciales.
      <br>
      * Hacer buen uso del servicio en general.
    </p>
    <br>
    <b>ALCANCE DEL SERVICIO:</b>
    <br>
    <p class="text-justify">
      El simulador ha sido diseñado para permitir al usuario realizar un estimativo de los costos que debe tener en
      cuenta en el proceso de desarrollo empresarial, la CCMA no garantiza la vigencia de las tarifas ni la exactitud
      de las mismas en los trámites que abarca, por lo anterior es responsabilidad del usuario ratificar los valores
      que proyecta el simulador con cada una de las entidades vinculadas a la herramienta.
      <br>
      Para calcular los costos asociados a los trámites que se adelantan ante OSA, Sayco, Acinpro e INVIMA, cuando
      sea necesario por las características del negocio o de los productos o servicios que se prestan, es
      responsabilidad del usuario acceder a los links incluidos en las preguntas que lo llevan directamente al
      sitio web de estas entidades, quienes cuentan con un simulador de costos para los trámites que se realizan
      ante estas instituciones. Una vez el usuario ingresa al simulador incluido en el sitio web diferente al de
      la CCMA, es responsable de ingresar el valor a pagar arrojado, en el simulador de costos de la CCMA para
      que sea incluido en el resultado final.
      <br>
      La CCMA no es responsable de la funcionalidad de los sitios web, su disponibilidad permanente o veracidad
      en el resultado que arrojen. Así mismo, es responsabilidad del usuario utilizar los links incluidos en
      algunas ayudas en caso de tener dudas con la respuesta que va a incluir en el simulador, ya que este enlace
      le permite el usuario conocer de forma amplia los diferentes trámites que se llevan cabo en cada entidad y
      las diferencias entre ellos. La inclusión de cualquiera de estos enlaces no implica aprobación por parte de
      la Cámara de Comercio de Cartagena a ninguno de estos sitios ni ninguna asociación con sus operadores.
      <br>
      Para los efectos del simulador se entenderá por Pequeña Empresa Joven aquella que cumpla las siguientes condiciones:
      <br>
      La empresa conformada por personas naturales que tengan entre 18 y hasta 35 años. Tratándose de las personas
      jurídicas, la empresa que tenga participación de uno o varios jóvenes como socios o accionistas y que
      tengan entre 18 y hasta 35 años, que representen como mínimo la mitad más uno de las cuotas, acciones o
      participaciones en que se divide su capital.
      <br>
      La empresa cuyo personal no sea superior a 50 trabajadores y cuyos activos totales no superen los 5.000 salarios
      mínimos mensuales legales vigentes.
      <br>
      *Estos requisitos deben ser concurrentes.
      <br>
      <b>Beneficiarias de la Ley de emprendimiento juvenil</b>: Las personas naturales y jurídicas que conformen pequeñas
      empresas jóvenes, que inicien su actividad económica a partir de la promulgación de la Ley y que no estén dentro
      del régimen de exclusiones. Se entenderá por inicio de la actividad económica principal la fecha de inscripción
      en el registro mercantil de la correspondiente Cámara de Comercio.
      <br>
      <b>Beneficios</b>: De conformidad con lo previsto en el artículo 3° de la ley 1780 de 2016, el beneficio
      consiste en la exención del pago de la matrícula mercantil y de la renovación del primer año siguiente al
      inicio de la actividad económica principal.
      <br>
      <b>Perdida de los beneficios</b>: Los beneficios de que trata el artículo 3° de la Ley, se perderán en los
      siguientes eventos:
      <br>
      <b>a)</b>&nbsp;Incumplimiento de la renovación de la matrícula mercantil dentro de los tres (3) primeros
      meses del año.
      <br>
      <b>b)</b>&nbsp;Impago de los aportes al Sistema de Seguridad Social Integral y demás contribuciones de nómina
      de la empresa.
      <br>
      <b>c)</b>&nbsp;Incumplimiento de las obligaciones en materia tributaria.
      <br>
      <br>
      <br>
      * Para efectos del no cobro de la primera renovación la persona natural o jurídica, deberá declarar que mantiene
      el cumplimiento de los requisitos estipulados.
      <br>
      Las condiciones que debe cumplir La pequeña empresa joven determinadas en este documento podrán variar de
      acuerdo a la reglamentación que se expida en la materia. El simulador podrá variar las preguntas o la información
      en cualquier momento para cumplir con las modificaciones o actualizaciones normativas en el tema.
      <br>
      La información determinante para liquidar los pagos en la CCMA será la contenida en los documentos que se
      presentan en las taquillas de la Cámara y no la información incluida en el simulador, en este sentido, si el
      simulador arroja un valor de cero pesos por concepto de matrícula persona natural o jurídica, el usuario acepta
      que esta tarifa podrá variar según la información presentada al momento de radicar el trámite, relacionada con
      el cumplimiento de las condiciones que se requieren para ser catalogada como pequeña empresa joven.
      <br>
      Lo mismo sucede con el concepto identificado como “Pago renovación anual de la matrícula mercantil del
      comerciante” en el cuadro correspondiente a los costos del año dos, si el valor arrojado por el simulador
      es cero, el usuario acepta que esta tarifa podrá variar si no mantiene el cumplimiento de los requisitos
      estipulados para ser pequeña empresa joven, o en el caso de pérdida de beneficios o en el evento de cambios
      normativos que impida la aplicación de los beneficios.
      <br>
      El costo aproximado del impuesto de Industria y Comercio debe ser ratificado con la alcaldía municipal encargada
      de su recaudo, las tarifas incluidas en el simulador pueden ser modificadas por cada alcaldía municipal de
      los 69 municipios sin previo aviso a la CCMA, por lo anterior el usuario es responsable de verificar la
      vigencia de los costos vinculados a este tributo de carácter municipal.
    </p>
    <br>
    <b>RESTRICCIONES.</b>
    <br>
    <p class="text-justify">
      <b>-</b>&nbsp;Los costos que arroja el simulador o la impresión de los mismos no reemplazan las liquidaciones que
      realizan las entidades vinculadas el simulador, no constituye una pre liquidación, ni puede presentarse para
      realizar reclamos por las diferencias entre los pagos que arroja el simulador y las liquidaciones que realiza
      cada entidad al momento de recibir la solicitud de radicación de cada trámite.
      <br>
      <b>-</b>&nbsp;No será posible realizar reclamos frente a la CCMA o frente a cualquiera de las entidades vinculadas
      al simulador, por las diferencias que se tengan entre los pagos que arroja el servicio y las tarifas que liquida
      cada entidad con la presentación efectiva de la solicitud correspondiente.
      <br>
      <b>-</b>&nbsp;No será posible arrojar costos aproximados de usuarios cuyo domicilio corresponda a un municipio
      diferente a los indicados en las condiciones de acceso, lo mismo sucede cuando la ubicación del establecimiento de
      comercio corresponde a un municipio por fuera de la jurisdicción de la CCMA.
      <br>
      <b>-</b>&nbsp;El simulador no es un medio para radicar los trámites que liquida, para ello consulte el sitio web
      de cada entidad y siga las instrucciones que contenga para el efecto.
      <br>
      Teniendo en cuenta lo anterior, si el usuario advierte que las limitaciones y parámetros del simulador no se
      adecuan a sus necesidades o a las circunstancias especiales del trámite que pretende realizar, conoce que debe
      abstenerse de utilizarlo, pues esta herramienta no incluye la totalidad de trámites vinculados al proceso de
      desarrollo empresarial.
      <br>
      El uso del simulador no convierte a la Cámara de Comercio de Cartagena en un asesor jurídico o
      contable del usuario. De modo que la CCMA no asume ningún tipo de obligación con respecto a la pertinencia y
      procedencia de los trámites sujetos a costos aproximados. La pertinencia, legalidad y conveniencia de realizar
      cada uno de los trámites o de acogerse o no a los beneficios de la Ley de emprendimiento juvenil serán
      responsabilidad exclusiva del usuario, lo que implica que en ningún caso la Cámara de Comercio de Cartagena
      indemnizará los perjuicios que pudiera sufrir si lleva a cabo los trámites que no se adecuen a las
      condiciones de su negocio por la interpretación que el usuario le haya dado a la información publicada en el
      simulador o en los sitios web de las entidades vinculadas al mismo. Tampoco será sujeta a revisión de la CCMA la
      documentación que el usuario del servicio deba presentar frente a cada trámite que pretenda llevar a cabo,
      ni dará el visto bueno sobre la procedencia de los trámites seleccionados en el servicio.
      <br>
      En caso de considerarlo conveniente, la CCMA le recomienda buscar asesoría jurídica y contable profesional.En todo
      caso, puede solicitar información adicional en cada una de las entidades que hacen parte de los trámites incluidos
      en el simulador.
    </p>
    <br>
    <b>OTRAS CONSIDERACIONES DEL SERVICIO:</b>
    <br>
    <p class="text-justify">
      Tenga en cuenta que la información que ingrese al simulador se cargará durante y podrá recuperarla cada vez que
      ingrese con su número de identificación y correo electrónico al servicio. Al finalizar este tiempo los datos
      ingresados serán eliminados y el usuario deberá responder nuevamente las preguntas necesarias para arrojar los
      pagos aproximados en Cámara y los pagos aproximados con otras entidades.
    </p>
    <br>
    <b>CONDICIONES O RESTRICCIONES DE USO DEL CONTENIDO:</b>
    <br>
    <p class="text-justify">
      Usted se compromete a hacer un uso adecuado del simulador. De manera enunciativa, pero no limitativa, usted
      se compromete a NO:
      <br>
      <b>1.</b>&nbsp;Utilizar el contenido para incurrir y/o incitar a terceros a incurrir en actividades ilícitas,
      ilegales o contrarias a la buena fe y al orden público, o para difundir contenidos o propaganda de carácter
      racista, xenófobo, pornográfico, de apología del terrorismo o atentatorio contra los derechos humanos.
      <br>
      <b>2.</b>&nbsp;Usar secuencias de comandos automatizados para recopilar información publicada en el portal o a
      través del portal o para interactuar de cualquier otro modo con los mismos.
      <br>
      <b>3.</b>&nbsp;Provocar daños en los sistemas físicos y lógicos de la Cámara de Comercio de Cartagena, de
      sus proveedores o de terceras personas, introducir o difundir en la red virus informáticos,
      troyanos, código malicioso o cualesquiera otros sistemas físicos o lógicos que sean susceptibles de provocar
      daños en y/o estén diseñados para interrumpir, destruir o limitar la funcionalidad de cualquier software,
      hardware o equipo de telecomunicaciones o para dañar, deshabilitar, sobrecargar o perjudicar el portal de
      cualquier modo.
      <br>
      <b>4.</b>&nbsp;Intentar acceder, recolectar o almacenar los datos personales de otros visitantes y/o usuarios
      del simulador y, en su caso, utilizar las cuentas de correo electrónico de otros visitantes y/o usuarios y
      modificar o manipular sus mensajes.
      <br>
      <b>5.</b>&nbsp;No descargar, reproducir, copiar, enmarcar, compilar, cargar o republicar en ningún sitio de
      Internet, Intranet o Extranet, ni adaptar, modificar, transmitir, vender, comunicar al público, total o
      parcialmente, el contenido de la información que encontrará en el simulador. Cualquiera de estas actividades
      requiere de la autorización previa, expresa y por escrito de la Cámara de Comercio de Cartagena, so
      pena de incurrir en violación a los derechos de propiedad intelectual, y someterse a las consecuencias civiles
      y penales de tal hecho, así como al derecho de la Cámara de Comercio de Cartagena de revocar
      la autorización, aquí conferida.
      <br>
      <b>6.</b>&nbsp;No hacer uso del simulador para fines distintos a obtener un valor aproximado de algunos de los
      trámites necesarios para el proceso de desarrollo empresarial.
    </p>
    <br>
    <b>LIMITACIÓN DE RESPONSABILIDAD:</b>
    <br>
    <p class="text-justify">
      La Cámara de Comercio de Cartagena no es responsable por:
      <br>
      <b>1.</b>&nbsp;Las caídas del servicio virtual y la falla en el suministro del servicio, quedando exonerada por
      cualquier tipo de daños y perjuicios causados debido a la no disponibilidad y/o interrupción del servicio
      ocasionados por fallas o no disponibilidad de las redes y servicios de telecomunicaciones utilizados para
      soportar el portal, y que sean ajenos a su voluntad.
       <br>
      <b>2.</b>&nbsp;Los daños y perjuicios causados por virus informáticos, troyanos, código malicioso o cualesquiera
      otros sistemas físicos o lógicos a los sistemas de los usuarios.
       <br>
      <b>3.</b>&nbsp;Errores mecanográficos y/o tipográficos que aparezcan en el contenido.
       <br>
      <b>4.</b>&nbsp;El contenido o disponibilidad de los sitios vinculados mediante hipervínculos que aparezcan en el
      simulador (los "Sitios Vinculados"), incluyendo sin limitación, cualquier vínculo contenido en los Sitios
      Vinculados, cualquier cambio o actualización a los Sitios Vinculados, cualquier tipo de transmisión recibida o
      enviada desde o hacia Sitios Vinculados, o el funcionamiento incorrecto de los Sitios Vinculados.
       <br>
      <b>5.</b>&nbsp;La inactivación de los usuarios del sistema por realización de prácticas indebidas o restrictivas.
       <br>
      <b>6.</b>&nbsp;Por la información suministrada en el simulador que ocasione daños o perjuicios a terceros o
      se suplante la identidad de un tercero.
    </p>
    <br>
    <b>DERECHOS DE PROPIEDAD INTELECTUAL:</b>
    <br>
    <p class="text-justify">
      El contenido del simulador, incluyendo dentro de tal concepto los textos, la información, las imágenes, el diseño
      gráfico, las fotografías, los logos y el contenido multimedia; así como el software que soporta el simulador y sus
      licencias son de propiedad exclusiva de la Cámara de Comercio de Cartagena o de terceros que han
      otorgado licencia de uso a la misma lo que implica que todo el contenido del simulador está protegido por la
      Ley y no le confiere al usuario ningún derecho para su uso, almacenamiento, conservación, divulgación o
      explotación distinto al de la simple visualización y utilización para los efectos propios de la simulación
      de costos en el proceso de desarrollo empresarial.
    </p>
    <br>
    <b>CLÁUSULA COMPROMISORIA:</b>
    <br>
    <p class="text-justify">
      Las controversias surgidas entre la Cámara de Comercio de Cartagena y el(los) usuario(s) en
      razón de la existencia del contrato que por medio de estos términos de uso los vincula, o en razón de su
      interpretación, desarrollo o terminación, así como los derivados del incumplimiento contractual o la acción
      contractual o extracontractual de indemnización de perjuicios derivados del simulador, se someterán a la
      decisión de un (1) árbitro designado por sorteo entre la lista de sus árbitros por el Centro de Conciliación
      y Arbitraje del Colegio de Abogados de Cartagena. El arbitraje será en derecho, tendrá como sede la ciudad de
      Cartagena y se someterá a las normas que rigen el arbitraje legal.
    </p>
    <br>
    <b>LEGISLACIÓN APLICABLE:</b>
    <br>
    <p class="text-justify">
      Los presentes términos de uso se regirán e interpretarán de acuerdo con las normas vigentes en la República
      de Colombia, especialmente en las contenidas en el Código de Comercio; Ley 1780 de 2016, Estatutos tributarios
      de los municipios abordados para el simulador, Decisión 486 de 2000 y normas concordantes sobre propiedad
      intelectual, Ley 23 de 1982 y normas concordantes o complementarias sobre derechos de autor,
      Decreto 2200 de 2005, Decreto 4725 de 2005, Resolución 1403 de 2007, Resolución 2003 de 2004,
      Resolución 4002 de 2007, Resolución 4816 de 2008 y normas concordantes o complementarias sobre trámites
      ante el INVIMA, artículo 79 de la Constitución Nacional, Decreto ley 2811 de 1.974, Ley 23 de 1973,
      Ley 99 de 1993, Decreto 1753 de 1994, Decreto 2150 de 1995 y sus normas reglamentarias, complementarias o
      modificatorias sobre permisos ambientales.
    </p>
    `
  },

  /**
   * CHOCÓ
   */
  SIMULADOR_CCQ: {
    NombreCamara: 'Cámara de Comercio de Chocó',
    UrlCamara: 'https://www.camarachoco.org.co/',
    UrlCamaraShort: 'www.camarachoco.org.co',
    UrlMatApp: 'https://virtuales.camaramedellin.com.co/quibdo/MatriculaInscripcionVirtual/!/home/inicio',
    UrlDispatch: 'https://www.camaramedellin.com.co/servicios-registrales/acerca-de-los-servicios-registrales/taquilla-virtual',
    UrlCiiuConsult: 'http://virtuales.camaramedellin.com.co/consultas/ciiu.html',
    UrlWebServices: 'https://camaracomerciomedellin-f2723.web.app/services/',
    UrlRenovation: 'http://renovacionmatricula.camaramedellin.com.co/',
    UrlLogo: 'assets/images/logo-brand-CCQ.png',
    Location: 'Quibdó',
    privacyTerms: `
    “Los datos personales que se solicitan a través de esta página serán tratados por
    LA CAMARA DE COMERCIO DEL CHOCO, en adelante, LA CAMARA, de manera
    confiable y segura con la finalidad de entregar la simulación de costos de formalización
    solicitada por el USUARIO y cumplir con la prestación del servicio de manera idónea.
    Así mismo LA CAMARA podrá usar sus datos para informarle sobre nuestros productos,
    servicios y eventos; realizar gestión comercial para la promoción de tales servicios; realizar análisis
    prospectivo sobre tendencias y gustos de los consumidores que nos permitan otorgarles beneficios alrededor
    de la organización y análisis de la información que administra o gestiona LA CAMARA, bien en sus propios
    registros públicos o los de terceros. Consulte la Política de Protección de Datos Personales de la CAMARA
    en el link: <a href="http://www.camaramedellin.com.co/site/Terminos-y-Condiciones.aspx" target="_blank">
    http://www.camaramedellin.com.co/site/Terminos-y-Condiciones.aspx
    </a>.
    Cualquier consulta, reclamación, petición de modificación, rectificación o cancelación de sus datos
    personales podrá efectuarla a través del correo electrónico:
    <a href="mailto:habeasdata@camaramedellin.com.co"><span>habeasdata@camaramedellin.com.co</span></a>
    <br>
    <br>
    Manifiesto conocer la política de protección de datos de LA CAMARA y acepto el tratamiento de los datos
    entregados para los fines antes comunicados. Así mismo expreso que tengo facultad para llevar a cabo las
    operaciones requeridas para acceder al simulador de costos de Formalización.”
  `,
    userTerms: `
    <b> TÉRMINOS Y CONDICIONES DE USO PARA EL  SIMULADOR DE FORMALIZACIÓN.</b>
    <br>
    <p class="text-justify">
      En su propósito de contribuir al desarrollo empresarial, la Cámara de Comercio del Choco
      (en adelante también se identificará como La CCMA) pone a disposición del público el siguiente simulador
      que permite determinar los costos aproximados en los trámites más comunes en el proceso de formalización
      empresarial, en aras de proyectar los pagos aproximados necesarios para la adquisición de competencias
      fundamentales que le permiten al comerciante hacer parte del mercado competitivo.
      <br>
      El uso del simulador, la responsabilidad de la Cámara de Comercio del Choco y los deberes
      de los usuarios estarán regidos por las presentes condiciones de uso. Para tal propósito, el simulador
      dispondrá de las ayudas identificadas por un signo de interrogación ubicado en la parte derecha después
      del espacio destinado para la respuesta a cada pregunta. El cuestionario inicial permite determinar los
      costos vinculados a las entidades que intervienen en el ejercicio de actividades industriales, económicas
      y comerciales, donde el usuario es quien determina si desea conocer el costo de los trámites con todas las
      entidades vinculadas al simulador o solo algunos costos, bien sea porque la actividad que realiza no
      requiere todas las diligencias contempladas en la herramienta, o porque así lo decide el usuario del servicio.
      <br>
      La aceptación de las presentes condiciones de uso se hará, por parte del usuario al momento de hacer clic
      en la opción “he leído y acepto las condiciones del servicio y el aviso de privacidad”. La aceptación de las
      presentes condiciones de uso crea entre La CCMA y el usuario una relación de tipo contractual. Cualquier
      persona que desee acceder y/o utilizar el simulador podrá hacerlo sujetándose a estos términos y condiciones
      de uso, pero además se compromete a acatar todas las instrucciones e información incluida en el simulador, las
      cuales también se entienden incorporadas al presente acuerdo.
      <br>
      La CCMA se reserva el derecho a modificar en cualquier momento el contenido del simulador o las condiciones
      de uso, por lo tanto, se sugiere consultar periódicamente el contenido del mismo.
      <br>
      La simulación de costos aproximados en el proceso de desarrollo empresarial, referida en el presente documento
      de términos de uso, se adelantará únicamente a través de la herramienta dispuesta por la Cámara de Comercio
      del Choco y bajo las condiciones de uso que a continuación se describen.
    </p>
    <br>
    <b>CONDICIONES DE ACCESO:</b>
    <br>
    <p class="text-justify">
      El acceso al simulador de costos se realiza seleccionando la forma cómo se va a ejercer la actividad
      comercial, digitando número de identificación y correo electrónico, previa lectura y aceptación de
      las condiciones del servicio y el aviso de privacidad por parte del usuario.
      <br>
      El simulador solo aplica para los 20 municipios comprendidos dentro de la jurisdicción de la Cámara de
      Comercio del Choco: Quibdó, Istmina, Carmen de Atrato, Bojayá, Novita, Lloró, Bagadó, Condoto, Acandí, Sipi,
      Cantón de San Pablo, Nuquí, Alto Baudó, Bajo Baudó, Ríosucio, Juradó, Unguía, Litoral del San Juan, Atrato,
      Bahía Solano y Tadó.
      <br>
      El procedimiento para calcular los costos aproximados que arroja el simulador, se adelanta ingresando las
      respuestas de forma acertada a las preguntas relacionadas con la información que determina las tarifas a
      pagar en las entidades vinculadas al servicio, para tal fin, es necesario tener a la mano datos relacionados
      con los activos del comerciante, activos del negocio, número de empleados, edad de los comerciantes o socios
      de la persona jurídica que se pretende constituir, si usa obras que no son de su autoría, verificar si
      contamina los recursos naturales, entre otra información relevante para los datos del simulador.
      <br>
      Las personas que usen el simulador deben ser jurídicamente capaces en los términos previstos en la
      legislación colombiana vigente y es responsable de los datos ingresados en el simulador, incluidos
      los campos obligatorios y no obligatorios, deberán ser veraces y fidedignos. La CCMA no será responsable
      por las inexactitudes, omisiones o falsedades en que pueda incurrir el usuario al revelar la información requerida.
      <br>
      En suma, para ingresar al simulador se requiere el cumplimiento de las siguientes condiciones:
      <br>
      * Leer las condiciones de uso y el aviso de privacidad
      <br>
      * Seleccionar la forma cómo va a ejercer la actividad comercial (persona natural o persona jurídica)
      <br>
      * Digitar el número de identificación del usuario.
      <br>
      * Digitar un correo electrónico.
      <br>
      * Revelar información fidedigna y veraz.
      <br>
      * No incurrir en malas prácticas comerciales.
      <br>
      * Hacer buen uso del servicio en general.
    </p>
    <br>
    <b>ALCANCE DEL SERVICIO:</b>
    <br>
    <p class="text-justify">
      El simulador ha sido diseñado para permitir al usuario realizar un estimativo de los costos que debe tener en
      cuenta en el proceso de desarrollo empresarial, la CCMA no garantiza la vigencia de las tarifas ni la exactitud
      de las mismas en los trámites que abarca, por lo anterior es responsabilidad del usuario ratificar los valores
      que proyecta el simulador con cada una de las entidades vinculadas a la herramienta.
      <br>
      Para calcular los costos asociados a los trámites que se adelantan ante OSA, Sayco, Acinpro e INVIMA, cuando
      sea necesario por las características del negocio o de los productos o servicios que se prestan, es
      responsabilidad del usuario acceder a los links incluidos en las preguntas que lo llevan directamente al
      sitio web de estas entidades, quienes cuentan con un simulador de costos para los trámites que se realizan
      ante estas instituciones. Una vez el usuario ingresa al simulador incluido en el sitio web diferente al de
      la CCMA, es responsable de ingresar el valor a pagar arrojado, en el simulador de costos de la CCMA para
      que sea incluido en el resultado final.
      <br>
      La CCMA no es responsable de la funcionalidad de los sitios web, su disponibilidad permanente o veracidad
      en el resultado que arrojen. Así mismo, es responsabilidad del usuario utilizar los links incluidos en
      algunas ayudas en caso de tener dudas con la respuesta que va a incluir en el simulador, ya que este enlace
      le permite el usuario conocer de forma amplia los diferentes trámites que se llevan cabo en cada entidad y
      las diferencias entre ellos. La inclusión de cualquiera de estos enlaces no implica aprobación por parte de
      la Cámara de Comercio del Choco a ninguno de estos sitios ni ninguna asociación con sus operadores.
      <br>
      Para los efectos del simulador se entenderá por Pequeña Empresa Joven aquella que cumpla las siguientes condiciones:
      <br>
      La empresa conformada por personas naturales que tengan entre 18 y hasta 35 años. Tratándose de las personas
      jurídicas, la empresa que tenga participación de uno o varios jóvenes como socios o accionistas y que
      tengan entre 18 y hasta 35 años, que representen como mínimo la mitad más uno de las cuotas, acciones o
      participaciones en que se divide su capital.
      <br>
      La empresa cuyo personal no sea superior a 50 trabajadores y cuyos activos totales no superen los 5.000 salarios
      mínimos mensuales legales vigentes.
      <br>
      *Estos requisitos deben ser concurrentes.
      <br>
      <b>Beneficiarias de la Ley de emprendimiento juvenil</b>: Las personas naturales y jurídicas que conformen pequeñas
      empresas jóvenes, que inicien su actividad económica a partir de la promulgación de la Ley y que no estén dentro
      del régimen de exclusiones. Se entenderá por inicio de la actividad económica principal la fecha de inscripción
      en el registro mercantil de la correspondiente Cámara de Comercio.
      <br>
      <b>Beneficios</b>: De conformidad con lo previsto en el artículo 3° de la ley 1780 de 2016, el beneficio
      consiste en la exención del pago de la matrícula mercantil y de la renovación del primer año siguiente al
      inicio de la actividad económica principal.
      <br>
      <b>Perdida de los beneficios</b>: Los beneficios de que trata el artículo 3° de la Ley, se perderán en los
      siguientes eventos:
      <br>
      <b>a)</b>&nbsp;Incumplimiento de la renovación de la matrícula mercantil dentro de los tres (3) primeros
      meses del año.
      <br>
      <b>b)</b>&nbsp;Impago de los aportes al Sistema de Seguridad Social Integral y demás contribuciones de nómina
      de la empresa.
      <br>
      <b>c)</b>&nbsp;Incumplimiento de las obligaciones en materia tributaria.
      <br>
      <br>
      <br>
      * Para efectos del no cobro de la primera renovación la persona natural o jurídica, deberá declarar que mantiene
      el cumplimiento de los requisitos estipulados.
      <br>
      Las condiciones que debe cumplir La pequeña empresa joven determinadas en este documento podrán variar de
      acuerdo a la reglamentación que se expida en la materia. El simulador podrá variar las preguntas o la información
      en cualquier momento para cumplir con las modificaciones o actualizaciones normativas en el tema.
      <br>
      La información determinante para liquidar los pagos en la CCMA será la contenida en los documentos que se
      presentan en las taquillas de la Cámara y no la información incluida en el simulador, en este sentido, si el
      simulador arroja un valor de cero pesos por concepto de matrícula persona natural o jurídica, el usuario acepta
      que esta tarifa podrá variar según la información presentada al momento de radicar el trámite, relacionada con
      el cumplimiento de las condiciones que se requieren para ser catalogada como pequeña empresa joven.
      <br>
      Lo mismo sucede con el concepto identificado como “Pago renovación anual de la matrícula mercantil del
      comerciante” en el cuadro correspondiente a los costos del año dos, si el valor arrojado por el simulador
      es cero, el usuario acepta que esta tarifa podrá variar si no mantiene el cumplimiento de los requisitos
      estipulados para ser pequeña empresa joven, o en el caso de pérdida de beneficios o en el evento de cambios
      normativos que impida la aplicación de los beneficios.
      <br>
      El costo aproximado del impuesto de Industria y Comercio debe ser ratificado con la alcaldía municipal encargada
      de su recaudo, las tarifas incluidas en el simulador pueden ser modificadas por cada alcaldía municipal de
      los 69 municipios sin previo aviso a la CCMA, por lo anterior el usuario es responsable de verificar la
      vigencia de los costos vinculados a este tributo de carácter municipal.
    </p>
    <br>
    <b>RESTRICCIONES.</b>
    <br>
    <p class="text-justify">
      <b>-</b>&nbsp;Los costos que arroja el simulador o la impresión de los mismos no reemplazan las liquidaciones que
      realizan las entidades vinculadas el simulador, no constituye una pre liquidación, ni puede presentarse para
      realizar reclamos por las diferencias entre los pagos que arroja el simulador y las liquidaciones que realiza
      cada entidad al momento de recibir la solicitud de radicación de cada trámite.
      <br>
      <b>-</b>&nbsp;No será posible realizar reclamos frente a la CCMA o frente a cualquiera de las entidades vinculadas
      al simulador, por las diferencias que se tengan entre los pagos que arroja el servicio y las tarifas que liquida
      cada entidad con la presentación efectiva de la solicitud correspondiente.
      <br>
      <b>-</b>&nbsp;No será posible arrojar costos aproximados de usuarios cuyo domicilio corresponda a un municipio
      diferente a los indicados en las condiciones de acceso, lo mismo sucede cuando la ubicación del establecimiento de
      comercio corresponde a un municipio por fuera de la jurisdicción de la CCMA.
      <br>
      <b>-</b>&nbsp;El simulador no es un medio para radicar los trámites que liquida, para ello consulte el sitio web
      de cada entidad y siga las instrucciones que contenga para el efecto.
      <br>
      Teniendo en cuenta lo anterior, si el usuario advierte que las limitaciones y parámetros del simulador no se
      adecuan a sus necesidades o a las circunstancias especiales del trámite que pretende realizar, conoce que debe
      abstenerse de utilizarlo, pues esta herramienta no incluye la totalidad de trámites vinculados al proceso de
      desarrollo empresarial.
      <br>
      El uso del simulador no convierte a la Cámara de Comercio del Choco en un asesor jurídico o
      contable del usuario. De modo que la CCMA no asume ningún tipo de obligación con respecto a la pertinencia y
      procedencia de los trámites sujetos a costos aproximados. La pertinencia, legalidad y conveniencia de realizar
      cada uno de los trámites o de acogerse o no a los beneficios de la Ley de emprendimiento juvenil serán
      responsabilidad exclusiva del usuario, lo que implica que en ningún caso la Cámara de Comercio del Choco
      indemnizará los perjuicios que pudiera sufrir si lleva a cabo los trámites que no se adecuen a las
      condiciones de su negocio por la interpretación que el usuario le haya dado a la información publicada en el
      simulador o en los sitios web de las entidades vinculadas al mismo. Tampoco será sujeta a revisión de la CCMA la
      documentación que el usuario del servicio deba presentar frente a cada trámite que pretenda llevar a cabo,
      ni dará el visto bueno sobre la procedencia de los trámites seleccionados en el servicio.
      <br>
      En caso de considerarlo conveniente, la CCMA le recomienda buscar asesoría jurídica y contable profesional.En todo
      caso, puede solicitar información adicional en cada una de las entidades que hacen parte de los trámites incluidos
      en el simulador.
    </p>
    <br>
    <b>OTRAS CONSIDERACIONES DEL SERVICIO:</b>
    <br>
    <p class="text-justify">
      Tenga en cuenta que la información que ingrese al simulador se cargará durante y podrá recuperarla cada vez que
      ingrese con su número de identificación y correo electrónico al servicio. Al finalizar este tiempo los datos
      ingresados serán eliminados y el usuario deberá responder nuevamente las preguntas necesarias para arrojar los
      pagos aproximados en Cámara y los pagos aproximados con otras entidades.
    </p>
    <br>
    <b>CONDICIONES O RESTRICCIONES DE USO DEL CONTENIDO:</b>
    <br>
    <p class="text-justify">
      Usted se compromete a hacer un uso adecuado del simulador. De manera enunciativa, pero no limitativa, usted
      se compromete a NO:
      <br>
      <b>1.</b>&nbsp;Utilizar el contenido para incurrir y/o incitar a terceros a incurrir en actividades ilícitas,
      ilegales o contrarias a la buena fe y al orden público, o para difundir contenidos o propaganda de carácter
      racista, xenófobo, pornográfico, de apología del terrorismo o atentatorio contra los derechos humanos.
      <br>
      <b>2.</b>&nbsp;Usar secuencias de comandos automatizados para recopilar información publicada en el portal o a
      través del portal o para interactuar de cualquier otro modo con los mismos.
      <br>
      <b>3.</b>&nbsp;Provocar daños en los sistemas físicos y lógicos de la Cámara de Comercio del Choco, de
      sus proveedores o de terceras personas, introducir o difundir en la red virus informáticos,
      troyanos, código malicioso o cualesquiera otros sistemas físicos o lógicos que sean susceptibles de provocar
      daños en y/o estén diseñados para interrumpir, destruir o limitar la funcionalidad de cualquier software,
      hardware o equipo de telecomunicaciones o para dañar, deshabilitar, sobrecargar o perjudicar el portal de
      cualquier modo.
      <br>
      <b>4.</b>&nbsp;Intentar acceder, recolectar o almacenar los datos personales de otros visitantes y/o usuarios
      del simulador y, en su caso, utilizar las cuentas de correo electrónico de otros visitantes y/o usuarios y
      modificar o manipular sus mensajes.
      <br>
      <b>5.</b>&nbsp;No descargar, reproducir, copiar, enmarcar, compilar, cargar o republicar en ningún sitio de
      Internet, Intranet o Extranet, ni adaptar, modificar, transmitir, vender, comunicar al público, total o
      parcialmente, el contenido de la información que encontrará en el simulador. Cualquiera de estas actividades
      requiere de la autorización previa, expresa y por escrito de la Cámara de Comercio del Choco, so
      pena de incurrir en violación a los derechos de propiedad intelectual, y someterse a las consecuencias civiles
      y penales de tal hecho, así como al derecho de la Cámara de Comercio del Choco de revocar
      la autorización, aquí conferida.
      <br>
      <b>6.</b>&nbsp;No hacer uso del simulador para fines distintos a obtener un valor aproximado de algunos de los
      trámites necesarios para el proceso de desarrollo empresarial.
    </p>
    <br>
    <b>LIMITACIÓN DE RESPONSABILIDAD:</b>
    <br>
    <p class="text-justify">
      La Cámara de Comercio del Choco no es responsable por:
      <br>
      <b>1.</b>&nbsp;Las caídas del servicio virtual y la falla en el suministro del servicio, quedando exonerada por
      cualquier tipo de daños y perjuicios causados debido a la no disponibilidad y/o interrupción del servicio
      ocasionados por fallas o no disponibilidad de las redes y servicios de telecomunicaciones utilizados para
      soportar el portal, y que sean ajenos a su voluntad.
       <br>
      <b>2.</b>&nbsp;Los daños y perjuicios causados por virus informáticos, troyanos, código malicioso o cualesquiera
      otros sistemas físicos o lógicos a los sistemas de los usuarios.
       <br>
      <b>3.</b>&nbsp;Errores mecanográficos y/o tipográficos que aparezcan en el contenido.
       <br>
      <b>4.</b>&nbsp;El contenido o disponibilidad de los sitios vinculados mediante hipervínculos que aparezcan en el
      simulador (los "Sitios Vinculados"), incluyendo sin limitación, cualquier vínculo contenido en los Sitios
      Vinculados, cualquier cambio o actualización a los Sitios Vinculados, cualquier tipo de transmisión recibida o
      enviada desde o hacia Sitios Vinculados, o el funcionamiento incorrecto de los Sitios Vinculados.
       <br>
      <b>5.</b>&nbsp;La inactivación de los usuarios del sistema por realización de prácticas indebidas o restrictivas.
       <br>
      <b>6.</b>&nbsp;Por la información suministrada en el simulador que ocasione daños o perjuicios a terceros o
      se suplante la identidad de un tercero.
    </p>
    <br>
    <b>DERECHOS DE PROPIEDAD INTELECTUAL:</b>
    <br>
    <p class="text-justify">
      El contenido del simulador, incluyendo dentro de tal concepto los textos, la información, las imágenes, el diseño
      gráfico, las fotografías, los logos y el contenido multimedia; así como el software que soporta el simulador y sus
      licencias son de propiedad exclusiva de la Cámara de Comercio del Choco o de terceros que han
      otorgado licencia de uso a la misma lo que implica que todo el contenido del simulador está protegido por la
      Ley y no le confiere al usuario ningún derecho para su uso, almacenamiento, conservación, divulgación o
      explotación distinto al de la simple visualización y utilización para los efectos propios de la simulación
      de costos en el proceso de desarrollo empresarial.
    </p>
    <br>
    <b>CLÁUSULA COMPROMISORIA:</b>
    <br>
    <p class="text-justify">
      Las controversias surgidas entre la Cámara de Comercio del Choco y el(los) usuario(s) en
      razón de la existencia del contrato que por medio de estos términos de uso los vincula, o en razón de su
      interpretación, desarrollo o terminación, así como los derivados del incumplimiento contractual o la acción
      contractual o extracontractual de indemnización de perjuicios derivados del simulador, se someterán a la
      decisión de un (1) árbitro designado por sorteo entre la lista de sus árbitros por el Centro de Conciliación
      y Arbitraje del Colegio de Abogados del Choco. El arbitraje será en derecho, tendrá como sede la ciudad del
      Choco y se someterá a las normas que rigen el arbitraje legal.
    </p>
    <br>
    <b>LEGISLACIÓN APLICABLE:</b>
    <br>
    <p class="text-justify">
      Los presentes términos de uso se regirán e interpretarán de acuerdo con las normas vigentes en la República
      de Colombia, especialmente en las contenidas en el Código de Comercio; Ley 1780 de 2016, Estatutos tributarios
      de los municipios abordados para el simulador, Decisión 486 de 2000 y normas concordantes sobre propiedad
      intelectual, Ley 23 de 1982 y normas concordantes o complementarias sobre derechos de autor,
      Decreto 2200 de 2005, Decreto 4725 de 2005, Resolución 1403 de 2007, Resolución 2003 de 2004,
      Resolución 4002 de 2007, Resolución 4816 de 2008 y normas concordantes o complementarias sobre trámites
      ante el INVIMA, artículo 79 de la Constitución Nacional, Decreto ley 2811 de 1.974, Ley 23 de 1973,
      Ley 99 de 1993, Decreto 1753 de 1994, Decreto 2150 de 1995 y sus normas reglamentarias, complementarias o
      modificatorias sobre permisos ambientales.
    </p>
    `
  }
};
